<!--
 * @Author: lijiahui
 * @Date: 2020-02-03 15:20:55
 * @LastEditTime: 2020-12-23 10:54:52
 * @LastEditors: Niu Chenxin
 * @Description: 生长记录页面
 * @FilePath: \xingmahui_front\src\views\growth\growthrecord.vue
 -->
<template>
  <div class="growthRecord">
    <span class="back" @click="goback"><img src="../../../assets/images/grow/back2.png" alt=""></span>
    <div class="growth_tab">

      <!-- 生长发育曲线 成长发育曲线-->
      <div class="tab1_list">
        <div class="titleWrap">
          <div class="title growth title_active" @click="switchPage(1)" v-if="!babyState">
            成长发育曲线
          </div>
          <div class="title growth title_active" @click="showHander()" v-if="babyState">
            <div>{{title}}<img src="../../../assets/images/baby/3.jpg" /></div>
          </div>
          <div class="selector-down">
            <div class="selector-option">
              <ul class="option">
                <li class="option" v-for="item in optionList" :key="item.id" @click="seletHander(item.name,item.id)">{{item.name}}</li>
              </ul>
            </div>
          </div>
          <div class="title proposal" @click="switchPage(2)">评估与建议</div>
          <span class="lineL" v-if="growShow"></span>
          <span class="lineR" v-if="!growShow"></span>
        </div>

        <div v-show="chartsShow" class="wrap">
          <div class="item head head_active" @click="switchPageState(2)">头围</div>
          <div class="item height" @click="switchPageState(0)"><span class="lineL"></span>身高<span class="lineR"></span></div>
          <div class="item weight" @click="switchPageState(1)">体重</div>
        </div>
        <grow-Table v-if="chartsShow" :heightShow="heightShow" :weightShow="weightShow" :headShow="headShow" :babySex="babySex" :babyNum="babyNum" :noBabyBir="noBabyBir" :babyBir="babyBir" :babyHeadShow="babyHeadShow"></grow-Table>
        <evaluate-Proposal v-if="evaluateProposal" :babyHeadShow="babyHeadShow"></evaluate-Proposal>
      </div>
      <!-- 评估与建议 -->
      <!--<div class="tab2_list">
          <span class="title">评估与建议</span>
        </div> -->
    </div>
    <!-- 添加记录 -->
    <div class="addRecord">
      <span @click="toAddRecord">添加记录</span>
    </div>
  </div>
</template>

<style lang="less" scoped>
.growthRecord {
  background: #fff;
  position: relative;
  min-height: 100%;
  overflow: hidden;
  padding-bottom: 130px;
  .back {
    position: fixed;
    top: 15px;
    left: 15px;
    width: 35px;
    height: 25px;
    z-index: 100;
    img {
      width: 7px;
      height: 12px;
    }
  }
  .growth_tab {
    .tab1_list {
      .titleWrap {
        background: #fff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        border-bottom: 1px solid #eee;
        .title {
          width: 50%;
          height: 43px;
          line-height: 43px;
          text-align: center;
          display: inline-block;
          font-size: 13px;
        }
        .title_active {
          font-size: 13px;
          font-weight: bold;
          font-family: PingFangSC-Semibold, PingFang SC;
        }
        .lineL {
          width: 21px;
          height: 3px;
          background: #d6a036;
          border-radius: 2px;
          position: absolute;
          left: 22%;
          top: 36px;
        }
        .lineR {
          width: 21px;
          height: 3px;
          background: #d6a036;
          border-radius: 2px;
          position: absolute;
          left: 72%;
          top: 36px;
        }
        img {
          padding-left: 2px;
          padding-bottom: 2px;
          width: 7px;
          height: 5px;
        }
        //选项
        .selector-down {
          position: fixed;
          top: 45px;
          left: 35px;
          z-index: 100;
          text-align: center;
          display: none;
          .selector-option {
            padding-top: 10px;
            width: 116px;
            background: @expertFontColor255;
            box-shadow: 1px 3px 3px 0px rgba(142, 142, 142, 0.2);
            // border-top: 1px solid #F1F1F1;
            .active {
              color: #d4a437;
            }
            .option {
              line-height: 39px;
              font-size: @indexFontSize14;
            }
          }
        }
      }
      .wrap {
        width: 231px;
        height: 34px;
        margin: 0 auto;
        display: flex;
        margin-top: 70px;
        // position: relative;
        // top: 60px;
        // margin-bottom: 24px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 8px -2px rgba(0, 0, 0, 0.16);
        border-radius: 17px;
        border: 1px solid rgba(229, 229, 229, 1);
        .item {
          width: 33%;
          line-height: 34px;
          font-size: 12px;
          text-align: center;
          color: #cacaca;
          position: relative;
          padding-left: 20px;
          .lineL {
            width: 1px;
            height: 21px;
            background: #e5e5e5;
            display: inline-block;
            position: absolute;
            top: 6px;
            left: 0px;
          }
          .lineR {
            width: 1px;
            height: 21px;
            background: #e5e5e5;
            display: inline-block;
            position: absolute;
            top: 6px;
            right: 0px;
          }
        }
        .height {
          background-image: url('../../../assets/images/grow/height.png');
          background-repeat: no-repeat;
          background-position: 15px 8px;
          background-size: 18px 17px;
          color: #cacaca;
        }
        .weight {
          background-image: url('../../../assets/images/grow/weight.png');
          background-repeat: no-repeat;
          background-position: 15px 8px;
          background-size: 18px 17px;
          color: #cacaca;
        }
        .head {
          background-image: url('../../../assets/images/grow/head.png');
          background-repeat: no-repeat;
          background-position: 15px 8px;
          background-size: 18px 17px;
          color: #cacaca;
        }
        .height_active {
          background-image: url('../../../assets/images/grow/height_active.png');
          color: #9f80ff;
        }
        .weight_active {
          background-image: url('../../../assets/images/grow/weight_active.png');
          color: #ff8e8e;
        }
        .head_active {
          background-image: url('../../../assets/images/grow/head_active.png');
          color: #59e4be;
        }
      }
    }
  }
  .addRecord {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    padding-top: 10px;
    padding-bottom: 20px;
    span {
      margin: 0 auto;
      width: 284px;
      height: 36px;
      line-height: 36px;
      background: linear-gradient(
        270deg,
        rgba(212, 164, 55, 1) 0%,
        rgba(229, 191, 93, 1) 100%
      );
      border-radius: 30px;
      display: block;
      font-size: 16px;
      color: #fff;
      text-align: center;
      margin-top: 10px;
    }
  }
}
</style>


<script>
import growTable from "@/components/contents/grow/growTablev1.0.vue";
import evaluateProposal from "@/components/contents/grow/evaluateProposalv1.0.vue";
import API from "@/utils/axiosApi/growApi.js";
import { is_weixin, getCookie } from "@/assets/js/common.js";
export default {
  name: "growthRecord",
  components: { growTable, evaluateProposal },
  data () {
    return {
      curType: 0,
      chartsShow: true,
      evaluateProposal: false,
      babyNum: this.$route.query.num,
      babySex: '',
      babyBir: '', // 宝宝生日
      newDate: '',
      heightShow: false,
      weightShow: false,
      headShow: true,
      UserInfo: [],
      babyInfo: [],
      growShow: true,
      proposalShow: false,
      noBabyBir: false,
      babyHeadShow: '', // 宝宝出生1年后头围隐藏
      babyState: '', // 是否是从孕期转为出生后的状态
      title: "成长发育曲线",
      flag: false,
      optionList: [
        { id: 1, name: '孕期成长曲线' },
        { id: 2, name: '出生成长曲线' }
      ],
      titleState: true,
      source: ''
    };
  },
  computed: {},
  mounted () {

  },
  beforeRouteEnter: (to, from, next) => {
    next(vm => {
      if (vm.is_weixin()) {
        if (vm.getCookie("xmh_openid") == null || vm.getCookie("xmh_openid") == "") {//判断有没有openId
          location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
        } else {
          vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
          vm.getBabyInfo()
        }
      } else {
        vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
        vm.getBabyInfo()
      }
    })
  },
  created () { },
  mounted () {
    var shareDataParams = {
      shareLink: this.$http.hostName + "/home",
      shareDesc: '1000万中国家庭都在看！科学育儿，全程陪伴，源于母爱。',
      shareTitle: "星妈会",
      imgUrl: "https://image-mom.feihe.com/wxshare/home.png"//必须是绝对路径
    }
    this.wxJsSet.wxShare("fx", shareDataParams, this);
    sensors.track('GrowthCurvePage', {
      page_name: this.$route.meta.title,
      last_source: localStorage.getItem('growth_source'),
    })
    setTimeout(() => {
      if (this.$route.query.sourceFrom == 'profile') {
        if (this.$route.query.growth == 'true') {
          this.source = '个人中心特权位育儿贴士'
        } else {
          this.source = '个人中心宝宝卡片'
        }
      } else if (this.$route.query.sourceFrom == 'signIn') {
        this.source = '签到任务'
      } else if (this.$route.query.sourceFrom == 'homeBaby') {
        this.source = '宝宝求关注';
      } else {
        this.source = '首页成长曲线';
      }
      sensors.track('GrowthRecord_View', {
        GrowthRecord_View_Source: this.source,
      })
    }, 2000)
  },
  methods: {
    goback: function () {
      if (this.$route.query.sourceFrom == 'signIn') {
        // this.$router.go(-1)
        this.$router.push({ path: '/mine/signIn' })
      } else if (this.$route.query.sourceFrom == 'profile') {
        this.$router.push({ path: 'mine' })
      } else {
        this.$router.push({ path: 'home' })
      }
    },
    formatDate (inputTime) {
      var date = new Date(inputTime);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      this.newDate = y + '-' + m + '-' + d;
    },
    switchPage: function (name) {
      if (name == 1) {
        if (!this.noBabyBir) {
          if (this.titleState) {
            $(".growth").addClass("title_active")
            $(".proposal").removeClass("title_active")
            this.growShow = true
            this.chartsShow = true
            this.evaluateProposal = false
          } else {
            $(".growth").addClass("title_active")
            $(".proposal").removeClass("title_active")
            this.growShow = true
            this.chartsShow = true
            this.evaluateProposal = false
          }
        } else {
          $(".growth").addClass("title_active")
          $(".proposal").removeClass("title_active")
          this.growShow = true
          this.chartsShow = true
          this.evaluateProposal = false
        }
      } else if (name == 2) {
        $(".proposal").addClass("title_active")
        $(".growth").removeClass("title_active")
        $(".selector-down").slideUp();
        this.flag = false;
        this.growShow = false
        this.chartsShow = false
        this.evaluateProposal = true
        this.titleState = false
      }
    },

    // 显示选择箭头
    showHander: function () {
      if (!this.titleState) {
        this.titleState = true
        this.switchPage(1)
      } else {
        this.flag = !this.flag;
        if (this.flag) {
          $(".selector-down").slideDown();
        } else {
          $(".selector-down").slideUp();
        }
      }
    },
    // 选择列表某项
    seletHander: function (option, id) {
      this.flag = !this.flag;
      this.title = option
      if (id == '1') { // 孕期曲线表
        this.noBabyBir = true
      } else if (id == '2') { // 出生曲线表
        this.noBabyBir = false
      }
      $(".selector-down").slideUp();

    },
    // 获取宝宝信息
    getBabyInfo: function () {
      API.getBabyInfo({ crmId: this.UserInfo.crm_id }, res => {
        if (res.code == "200") {
          this.babyInfo = res.data
          for (var i = 0; i < this.babyInfo.length; i++) {
            if (this.babyNum == this.babyInfo[i].num) {
              this.babySex = this.babyInfo[i].sex
              this.babyBir = this.babyInfo[i].birth
              if (this.babySex != 'M' && this.babySex != 'F') {
                this.babySex = 'M'
              }
            }
          }
          if (this.babyInfo.length == 0) {
            // this.$router.push({path:'/home',})
            location.href = '/home'
          } else {
            var date = new Date()
            this.formatDate(date)
            if (this.babyBir > this.newDate) {
              this.noBabyBir = true
              this.title = '孕期成长曲线'
            } else {
              this.title = '出生成长曲线'
              var date = new Date()
              var nowDate = this.formatTime(date, "yyyy-MM-dd")
              var day = this.getDaysBetween(this.babyBir, nowDate)
              this.getBabyPregnRecord()
              if (day > 365) {
                this.babyHeadShow = false
              } else {
                this.babyHeadShow = true
              }
            }
          }
          if (this.$route.query.page == 2) {
            this.switchPage(2)
          }
        }
      })
    },
    // 查询孕期变为有宝 孕期是否填写记录
    getBabyPregnRecord: function () {
      API.getBabyPregnRecord({ crmId: this.UserInfo.crm_id, childNumber: this.babyNum, birthday: this.babyBir }, res => {
        if (res.code == "200") {
          this.babyState = res.data
        }
      })
    },
    // 身高 体重 头围 切换
    switchPageState: function (name, title) {
      if (name == 0) { // 身高
        this.heightShow = true
        this.weightShow = false
        this.headShow = false
        $(".item").removeClass("weight_active")
        $(".item").removeClass("head_active")
        $(".height").addClass("height_active")
      } else if (name == 1) {// 体重
        this.weightShow = true
        this.heightShow = false
        this.headShow = false
        $(".item").removeClass("height_active")
        $(".item").removeClass("head_active")
        $(".weight").addClass("weight_active")
      } else if (name == 2) {// 头围
        this.headShow = true
        this.heightShow = false
        this.weightShow = false
        $(".item").removeClass("height_active")
        $(".item").removeClass("weight_active")
        $(".head").addClass("head_active")
      }
    },
    formatTime: function (date, formatStr) {
      var str = formatStr;
      str = str.replace(/yyyy|YYYY/, date.getFullYear());
      str = str.replace(/MM/, (date.getMonth() + 1) > 9 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1));
      str = str.replace(/dd|DD/, date.getDate() > 9 ? date.getDate().toString() : '0' + date.getDate());
      str = str.replace(/hh|HH/, date.getHours() > 9 ? date.getHours().toString() : '0' + date.getHours());
      str = str.replace(/mm/, date.getMinutes() > 9 ? date.getMinutes().toString() : '0' + date.getMinutes());
      str = str.replace(/ss/, date.getSeconds() > 9 ? date.getSeconds().toString() : '0' + date.getSeconds());
      return str;
    },
    // 算出今天和宝宝生日相差的天数
    getDaysBetween: function (dateString1, dateString2) {
      var startDate = Date.parse(dateString1);
      var endDate = Date.parse(dateString2);
      var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      return days;
    },

    //  点击添加记录
    toAddRecord: function () {
      sensors.track('Tool_GrowthRecordPage_Add_Click', {
        GrowthRecordPage_Add_Click_Source: this.source
      })
      sensors.track('AddGrowthRecords')
      this.$router.push({
        path: '/growthRecord/addRecord',
        query: {
          num: this.babyNum,
          sourceFrom: this.$route.query.sourceFrom,
          source: this.$route.query.source
        }
      })
    },
    is_weixin, getCookie
  }
};
</script>
